"use strict";

require('../company/publications/CompanyPublicationFileService.js');

PublicationCollabrationDetailCtrl.$inject = [
  "$scope",
  "$interval",
  "$stateParams",
  "$translate",
  "translations",
  "$q",
  "config",
  "publication",
  "growl",
  "data",
  "PublicationCollabrationService"
];
function PublicationCollabrationDetailCtrl (
  $scope,
  $interval,
  $stateParams,
  $translate,
  translations,
  $q,
  config,
  publication,
  growl,
  data,
  PublicationCollabrationService
) {
  $scope.publication  = publication;
  $scope.showFileDrop = false;
  publication.type    = 'ALBUM';

  $scope.downloadZip = function() {
    var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
    if (true === iOS) {
      window.open(config.apiBase + '/companies/' + publication.company.id + '/publications/' + $stateParams.publicationId + '/zip?lang=' + window.localStorage.language, '_self');
      return;
    }
    
    var elm = angular.element(document.querySelector('body'));
    var iFrame = elm.find('#downloadWindow');
    if (!(iFrame && iFrame.length > 0)) {
      iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
      elm.append(iFrame);
    }

    iFrame.attr(
      'src',
      config.apiBase + '/companies/' + publication.company.id + '/publications/' + $stateParams.publicationId + '/zip?lang=' + window.localStorage.language
    );
  };
  
  var queryFiles =  function() {
    return PublicationCollabrationService.queryFiles({
      companyId:     publication.company.id,
      publicationId: $stateParams.publicationId,
      limit:         21,
      visible:       $stateParams.showInvisible === "true" ? "false" : "true",
      offset:        ($stateParams.page|0) * 20
    }).$promise.then(function(files) {
      $scope.files   = files.slice(0, 20);
      $scope.hasMore = files.length > 20;
    });
  };

  $scope.$on('collabration-uploaded', function() {
    queryFiles();
  });

  $scope.searchFileStr = $stateParams.searchFile || "";
  $scope.currentPage         = $stateParams.page|0;
  $scope.files         = data.files.slice(0, 21);
  $scope.hasMore       = data.files.length > 21;
}

PublicationCollabrationDetailCtrl.resolve = {
  data: [
  '$q',
  '$stateParams',
  'publication',
  'CompanyPublicationFileService',
  'PublicationCollabrationService',
  function(
    $q,
    $stateParams,
    publication,
    CompanyPublicationFileService,
    PublicationCollabrationService
    ) {

      var files = PublicationCollabrationService.queryFiles({
        companyId:     publication.company.id,
        publicationId: $stateParams.publicationId,
        limit:         22,
        visible:       $stateParams.showInvisible === "true" ? "false" : "true",
        offset:        ($stateParams.page|0) * 21,
        q:             $stateParams.searchFile || "",
        searchAble: true
      }).$promise;

      return $q.all([files]).then(function(data) {
        return {
          files      : data[0]
        };
      });
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.delete-file-failure',
      'publication.delete-file-success',
      'form.product-list.all'
    ]);
  }]
};

module.exports = PublicationCollabrationDetailCtrl;

angular.module("dokiv")
  .controller("PublicationCollabrationDetailCtrl", PublicationCollabrationDetailCtrl);

function isTypeImage() {
  return function(mimetype) {
    switch(mimetype) {
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
        case 'image/bmp':
        case 'image/svg+xml':
        case 'image/webp':
          return true;
        default:
          return false;
      }
  };
}

angular.module('dokiv')
  .filter('isTypeImage', isTypeImage);


//////////////////
// WEBPACK FOOTER
// ./scripts/publication-collabrations/PublicationCollabrationDetailCtrl.js
// module id = 431
// module chunks = 0